<div class="row g-2 mb-2">
  <ng-container *ngIf="notification">
    <ng-container *ngIf="_notificationType === 'DEFAULT'">
      <div class="col notice-default" role="alert">
        <ng-container *ngIf="_tabidx !== -1;then link_content else normal_content"></ng-container>
        <ng-template #link_content>
          <button type="button" class="btn btn-link p-0 fw-bold" title="{{'Edit ' + _header}}" (click)="clickLink(_tabidx)"><i class="far fa-check-circle fa-md me-1" aria-hidden="true"></i> {{ _header }}</button>
        </ng-template>
        <ng-template #normal_content>
          <i class="far fa-check-circle fa-md me-1" aria-hidden="true"></i> <span class="fw-bold">{{ _header }}</span>
        </ng-template>
      </div>
    </ng-container>
    <ng-container *ngIf="_notificationType === 'WARNING'">
      <div class="col notice-orange" role="alert">
        <ng-container *ngIf="_tabidx !== -1;then link_content else normal_content"></ng-container>
        <ng-template #link_content>
          <button type="button" class="btn btn-link p-0 fw-bold" title="{{'Edit ' + _header}}" (click)="clickLink(_tabidx)"><i class="far fa-check-circle fa-md me-1" aria-hidden="true"></i> {{ _header }}</button>
        </ng-template>
        <ng-template #normal_content>
          <i class="far fa-check-circle fa-md me-1" aria-hidden="true"></i> <span class="fw-bold">{{_header}}</span>
        </ng-template>
        <div class="my-2"><i class="me-2 fas fa-exclamation-circle" aria-hidden="true"></i> <span [innerHTML]="_message"></span></div>
      </div>
    </ng-container>
    <ng-container *ngIf="_notificationType === 'ALERT'">
      <div class="col notice-red" role="alert">
        <ng-container *ngIf="_tabidx !== -1;then link_content else normal_content"></ng-container>
        <ng-template #link_content>
          <button type="button" class="btn btn-link p-0 fw-bold" title="{{'Edit ' + _header}}" (click)="clickLink(_tabidx)"><i class="far fa-check-circle fa-md me-1" aria-hidden="true"></i> {{ _header }}</button>
        </ng-template>
        <ng-template #normal_content>
          <i class="far fa-check-circle fa-md me-1" aria-hidden="true"></i> <span class="fw-bold">{{_header}}</span>
        </ng-template>
        <div class="my-2"><i class="me-2 fas fa-exclamation-triangle text-danger" aria-hidden="true"></i> <span [innerHTML]="_message"></span></div>
      </div>
    </ng-container>
    <ng-container *ngIf="_notificationType === 'DISABLE'">
      <div class="col notice-gray" role="alert">
        <ng-container *ngIf="_tabidx !== -1;then link_content else normal_content"></ng-container>
        <ng-template #link_content>
          <button type="button" class="btn btn-link p-0 fw-bold" title="{{'Edit ' + _header}}" (click)="clickLink(_tabidx)"><i class="far fa-check-circle fa-md me-1" aria-hidden="true"></i> {{ _header }}</button>
        </ng-template>
        <ng-template #normal_content>
          <i class="far fa-check-circle fa-md me-1" aria-hidden="true"></i> <span class="fw-bold">{{_header}}</span>
        </ng-template>
      </div>
    </ng-container>
    <ng-container *ngIf="_notificationType === 'SUCCESS'">
      <div class="col notice-green" role="alert">
        <i class="fas fa-info-circle fa-md me-1" aria-hidden="true"></i> <strong>{{_header}}</strong>
      </div>
    </ng-container>
  </ng-container>
  <div class="col-auto">
    <button type="button" class="btn btn-link p-0" title="{{'Edit ' + _header}}" (click)="clickLink(_tabidx)"><i class="fas fa-pencil-alt" aria-hidden="true"></i><span class="visually-hidden">Edit {{ _header }}</span></button>
  </div>
</div>
